import services from 'services/services';
import { useQuery } from 'react-query';

// Import api
import {
	QUERY_SUBSCRIBER_ACTIVE_AGREEMENTS,
	SUBSCRIBER_AGREEMENTS_API
} from 'helpers/api';

export const useFetchUserAcceptedAgreements = () => {
	const fetchUserAgreements = () => {
		return services.get(SUBSCRIBER_AGREEMENTS_API);
	};

	const { isLoading, isError, data } = useQuery({
		queryKey: QUERY_SUBSCRIBER_ACTIVE_AGREEMENTS,
		queryFn: fetchUserAgreements
	});

	const userAgreements = data?.data ?? [];
	const userActiveAgreements = userAgreements.filter(
		({ confirmed }) => confirmed
	);

	return {
		isUserActiveAgreementsLoading: isLoading,
		isUserActiveAgreementsError: isError,
		userActiveAgreements
	};
};

export default useFetchUserAcceptedAgreements;
